import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { TranslateService } from '@ngx-translate/core';
import { BasketOrderExtendedService } from '../../../../../../services/basket-order-extended.service';
import { AlertService } from '../../../../../../services/alert.service';
import { BasketOrderView } from '../../../../../../models/basket-order-view.model';
import { BillService } from '../../../../../../services/bill-service';
import { CtaAction } from '../../../../../../models/cta.action';
import { LIST_REFUNDED_STATUS } from '../../../../../../models/basket-order-refunded-status.model';

type BasketOrderViewTypeWithCTA = BasketOrderView & {
  ctaActions: CtaAction[];
};

@Component({
  selector: 'jhi-refunds-list',
  templateUrl: './refunds-list.component.html',
})
export class RefundsListComponent implements OnChanges {
  @Input() basketOrders: BasketOrderViewTypeWithCTA[] = [];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();
  PATHS = PATHS;
  actions!: CtaAction[];
  LIST_REFUNDED_STATUS = LIST_REFUNDED_STATUS;

  constructor(
    public translateService: TranslateService,
    public basketOrderService: BasketOrderExtendedService,
    public alertService: AlertService,
    private billService: BillService
  ) {
    this.actions = [{ label: this.translateService.instant('refund.refundBill'), action: 'bill' }];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['basketOrders'].currentValue) {
      this.basketOrders = changes['basketOrders'].currentValue;
    }
  }

  public goToBill(basketOrderId: number): void {
    this.billService.browserPdf(basketOrderId);
  }

  trackId(index: number, item: BasketOrderViewTypeWithCTA): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }
}
